<div class="deznav" (mouseover)="hoverAdd(true)" (mouseout)="hoverAdd(false)">
  <div class="deznav-scroll">
    <ul class="metismenu" id="menu">
      @for(item of sidebarMenu; track item){
      <li [ngClass]="{ 'mm-active': item.title == activeMenu }">
        @if(!item.route){
        <a
          (click)="$event.preventDefault(); handleMenu(item.title)"
          [ngClass]="{ 'has-arrow ai-icon': item.subMenu }"
          href="javascript:void(0)"
          [attr.aria-expanded]="item.title == activeMenu"
        >
          <i class="{{ item.icon }}"></i>
          <span class="nav-text ms-1 me-1">{{ item.title }}</span>
          @if(item.badge){
          <span class="badge badge-sm badge-danger ms-3">New</span>
          }
        </a>
        } @else if(item.route){
        <a
          (click)="handleMenu(item.title); closeMenu.emit()"
          [ngClass]="{ 'has-arrow ai-icon': item.subMenu }"
          [routerLink]="[item.route]"
          aria-expanded="false"
        >
          <i class="{{ item.icon }}"></i>
          <span class="nav-text ms-1">{{ item.title }}</span>
          @if(item.badge){
          <span class="badge badge-sm badge-danger ms-3">New</span>
          }
        </a>
        } @if(item.subMenu){
        <ul *ngIf="item.title == activeMenu" class="mm-sub" aria-expanded="true">
          @for(subitem of item?.subMenu; track subitem){
          <li [ngClass]="{ 'mm-active': subitem.title == activeSubMenu }">
            @if(subitem.route && !subitem.theme){
            <a
              (click)="handleActiveMenu(subitem.route); closeMenu.emit()"
              [routerLink]="[subitem.route]"
              [ngClass]="{ 'mm-active': subitem.title == activeSubMenu }"
            >
              {{ subitem.title }}
              @if(subitem.subBadge){
              <span class="badge badge-sm badge-danger ms-3">New</span>
              }
            </a>
            } @else if(!subitem.route && !subitem.theme){
            <a
              class="has-arrow ai-icon"
              [ngClass]="{ 'mm-active': subitem.title == activeSubMenu }"
              (click)="handleActiveSubMenu(subitem.title)"
              href="javascript:void(0)"
              aria-expanded="false"
            >
              {{ subitem.title }}
              @if(subitem.subBadge){
              <span class="badge badge-sm badge-danger ms-3">New</span>
              }
            </a>
            } @else if(subitem.route && subitem.theme){
            <a
              [ngClass]="{ 'mm-active': subitem.theme == elementValue }"
              (click)="themeMode(subitem.theme); closeMenu.emit()"
              [routerLink]="[subitem.route]"
            >
              {{ subitem.title }}
            </a>
            } @if(subitem.subsubMenu){
            <ul *ngIf="subitem.title == activeSubMenu" class="mm-sub" aria-expanded="true">
              @for(subSubItem of subitem.subsubMenu; track subSubItem){
              <li>
                <a
                  (click)="handleActiveMenu(subSubItem.route); closeMenu.emit()"
                  [routerLink]="[subSubItem.route]"
                  [ngClass]="{
                    'mm-active': subSubItem.title == activeSubSubMenu
                  }"
                >
                  {{ subSubItem.title }}
                </a>
              </li>
              }
            </ul>
            }
          </li>
          }
        </ul>
        }
      </li>
      }
    </ul>
    <div class="copyright">
      <p>
        <strong>Mesero Admin Dashboard</strong> ©
        <span class="current-year"> 2025 </span> All Rights Reserved
      </p>
      <!-- <p>Made with <span class="heart"></span> by DexignZone</p> -->
      <!-- <p class="fs-12">Made with 
                <span class="heart" [class.heart-blast] = "isVisited == true" (click) = "checkVisited()" ></span>
                 by DexignZone
            </p> -->
    </div>
  </div>
</div>
